module.exports = __webpack_public_path__ + "static/media/nyu.78ad86ea.png";